import { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Layout from "./client/Components/Layout";
import { useDispatch, useSelector } from "react-redux";
import { showMenu } from "./redux/Navigation/action";
import "rsuite/dist/rsuite.min.css";
import "./App.scss";
import Spinner from "client/CommonComponents/Spinner";
import AdminDash from "client/Components/Administraton/routes";
import CommonDashboard from "client/Components/CommonDashboard";
import useSignalR from "client/utils/useSignalR";
import OrderManagement from "client/Components/OrderManagement";
import CreateOrder from "client/Components/OrderManagement/Requisition";
import Asset from "client/Components/OrderManagement/Asset/TransferOrder/Asset";
import ApprovalOrder from "client/Components/OrderManagement/ApprovalOrder";
import AssetApproval from "client/Components/OrderManagement/Asset/AssetApproval";
import BlankPage from "client/Components/OrderManagement/BlankPage";
import UserDispatch from "Store/Identity/User/UserDispatch";
import AssetInventory from "client/Components/AssetInventory";
import ExceptionErrorLogs from "client/Components/ExceptionErrorLogs";
import AutoCompleteTest from "client/Components/AutoCompleteTest";
import CatalogManagement from "client/Components/OrderManagement/CatalogManagement";
import CreateAsset from "client/Components/OrderManagement/CatalogManagement/CreateAsset";
import ErrorPage from "client/Components/OrderManagement/BlankPage/ErrorPage";
import OrderDetailViewMainContainer from "client/Components/OrderManagement/OrderDetailViewMainContainer";
import PurchaseOrderMainContainer from "client/Components/OrderManagement/PurchaseOrderMainContainer";
import AssetOrderDetailViewMainContainer from "client/Components/OrderManagement/Asset/AssetOrderDetailViewMainContainer";
import AssetFleetProcessingMainContainer from "client/Components/OrderManagement/AssetFleetProcessingMainContainer";
import BulkOrder from "client/Components/OrderManagement/BulkOrder";
import CreateBulkOrder from "client/Components/OrderManagement/BulkOrder/CreateBulkOrder";
import CallUs from "client/Components/CallUs";
import DispositionPenaltyFee from "client/Components/OrderManagement/Reports/DispositionPenaltyFee";
import AcquisitionCodeMaintenanceListing from "client/Components/OrderManagement/Admin/AcquisitionCodeMaintenanceListing";
import AcquisitionCodeMaintenance from "client/Components/OrderManagement/AcquisitionCodeMaintenance";
import DispositionPenaltyFlag from "client/Components/OrderManagement/Admin/DispositionPenaltyFlag/DispositionPenaltyFlag-container";
import AddUserByCostCenter from "client/Components/AssetInventory/UsersComponent/AddUserByCostCenter/AddUserByCostCenter-Container";
import AssetAuditResetHistoryLog from "client/Components/OrderManagement/Admin/AssetAuditResetHistoryLog";
import BranchAdminAccess from "client/Components/AssetInventory/UsersComponent/BranchAdminAccess/BranchAdminAccess-Container";
import CreateJobTitle from "client/Components/OrderManagement/CatalogManagement/CreateJobTitle";
import ApprovalDashboard from "client/Components/OrderManagement/ApprovalDashboard";
import ApprovalHistoryDetails from "client/Components/OrderManagement/ApprovalDashboard/ApprovalHistoryReport/ApprovalHistoryDetails";
import ComplianceAuditReport from "client/Components/OrderManagement/ApprovalDashboard/ComplianceAuditReport";
import OutOfOffice from "client/Components/OrderManagement/Admin/OutOfOffice";
// import ActiveAsset from "client/Components/ActiveAsset";
import ActiveAssetDashboard from "client/Components/ActiveAsset/ActiveAssetDashboard";
import ActiveAssetRegister from "client/Components/ActiveAsset/ActiveAssetRegisters";
import ActiveAssetReport from "client/Components/ActiveAsset/ActiveAssetReport";
import Admin from "client/Components/OrderManagement/Admin";
import BarcodeReport from "client/Components/OrderManagement/Reports/BarcodeReport";


function App() {
  const { globalLoaderTxt } = useSelector((state: any) => state.CommonDashboard);
  const GlobalLoaderReducer = useSelector((state: any) => state.GlobalLoaderReducer);
  const { userId } = useSelector((state: any) => state.UserProfile.getUserDetails);
  const commonApiError = useSelector((state:any) => state.CommonErrorHandlerReducer?.commonApiError)

  const path = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathName = path?.pathname?.split("/")[1];
  useSignalR(userId);
  const webAppBaseUrl = process.env.REACT_APP_WEBAPP_API_BASE_URL


 const dispatchCurrentUser = UserDispatch.dispatchGetCurrentUser(dispatch);
 const dispatchGetCurrentUserByTimeInterval = UserDispatch.dispatchGetCurrentUserByTimeInterval(dispatch);
 
 useEffect(() => { 
    dispatchCurrentUser()
    const interval = setInterval(() => {
      dispatchGetCurrentUserByTimeInterval();
    }, (45 * 60000));
    return () => clearInterval(interval);
 }, []);

 const {currentUser} : any = useSelector(
  (state: any) => ({
    currentUser: state.UserReducer.currentUser
  }))


  const getSpinner = () => {
    let isLoading = false;
    let tempLoader = GlobalLoaderReducer
    Object.entries(tempLoader).forEach(([key, value]) => {
      if(value){
        isLoading = true;
      } 
    });
    if(globalLoaderTxt){
      return <Spinner text={globalLoaderTxt}  data-attribute="App_Default_Spinner" />
    }
    else if(isLoading){
      return <Spinner text={'Fetching Data ...'}  data-attribute="App_Default_Spinner_2" />   
    }
  }

  useEffect(() => {

    if (pathName === "OrderManagement" || pathName === "orderManagement" || pathName === "ordermanagement" || 
    pathName.toLowerCase() == 'CreateOrder'.toLowerCase() || pathName.toLowerCase() === 'AssetInventory'.toLowerCase()
    || pathName.toLowerCase() === 'ActiveAsset'.toLowerCase()) {
      dispatch(showMenu());
    }
  },[currentUser]);
  useEffect(()=>{
    if(commonApiError?.ErrorCode){
      navigate('/error-handling');
    }
  },[commonApiError])

  const saveInitialnavigationPathToSessionStore= (data: any) => {    
    sessionStorage.setItem("navigationPath", data);
  };

  const getSessionData = () => {    
    return sessionStorage.getItem("navigationPath");
  };

  const clearSessionData = () => {    
    sessionStorage.removeItem("navigationPath");
  };

  const navigationPath = getSessionData()  
  useEffect(()=>{
    if(navigationPath){      
      navigate(navigationPath)
      clearSessionData()
    }
  },[])

  useEffect(()=>{    
    if(currentUser && currentUser.error?.status === 401){      
      const navigationPath = window.location.pathname      
      saveInitialnavigationPathToSessionStore(navigationPath)
      window.location.href = `${webAppBaseUrl}`            
    }
  },[currentUser])

  return (
    <div className="App">
        {/*      <AuthenticatedTemplate>*/}
        {/* This condition is to check authorized user */}
        {Object.keys(currentUser).length !== 0 && currentUser.error?.status !== 401 ?
        (
          <Layout>
          <Routes>
            
            <Route path="/CommonDashboard" element={<CommonDashboard />} />
            <Route path="/ordermanagement" element={<OrderManagement />} />
            <Route path="/ordermanagement/requisitionorderapproval/:id" element={<ApprovalOrder isBulkOrder={false}/>} />
            <Route path="/ordermanagement/bulkorderapproval/:id" element={<ApprovalOrder isBulkOrder={true}/>} />
            <Route path="/ordermanagement/afeorderapproval/:id/:requesttype" element={<AssetApproval />} />
            <Route path="/ordermanagement/assetorderapproval/:id" element={<AssetApproval />} />
            <Route path="/ordermanagement/requisitionorderdetail/:id/:pagename/:activeassetnumber?" element={<OrderDetailViewMainContainer isBulkOrder={false}/>} />
            <Route path="/ordermanagement/bulkorderdetail/:id/:pagename" element={<OrderDetailViewMainContainer isBulkOrder={true}/>} />
            <Route path="/ordermanagement/assetorderdetail/:id/:pagename/:activeassetnumber?" element={<AssetOrderDetailViewMainContainer />} />
            <Route path="/ordermanagement/afeorderdetail/:id/:pagename/:requesttype" element={<AssetOrderDetailViewMainContainer />} />
            <Route path="/ordermanagement/fleetprocessingorderdetail/:id/:pagename" element={<PurchaseOrderMainContainer  isBulkOrder={false} />} />
            <Route path="/ordermanagement/fleetprocessingbulkorderdetail/:id/:pagename" element={<PurchaseOrderMainContainer isBulkOrder={true} />} />
            <Route path="/ordermanagement/fleetprocessingasset/:id/:pagename/:requesttype" element={<AssetFleetProcessingMainContainer/>} />
            <Route path="/administration/*" element={<AdminDash />} />
            <Route path="/ordermanagement/createorder" element={<CreateOrder />} />
            <Route path="/ordermanagement/assetcreateorder" element={<Asset />} />
            <Route path="/ordermanagement/createorder/:id/:orderflow" element={<CreateOrder />} />
            <Route path="/ordermanagement/assetcreateorder" element={<Asset />} />
            <Route path="/ordermanagement/assetcreateorder/:id/:orderflow/:orderType" element={<Asset />} />
            <Route path="/ordermanagement/catalogmanagement" element={<CatalogManagement/>} />
            <Route path="/ordermanagement/catalogmanagement/createasset" element={<CreateAsset/>} />
            <Route path="/ordermanagement/catalogmanagement/createasset/:id/:actionType" element={<CreateAsset/>} />
            <Route path="/ordermanagement/catalogmanagement/createjobTitle" element={<CreateJobTitle/>} />
            <Route path="/ordermanagement/catalogmanagement/createjobtitle/:id" element={<CreateJobTitle/>} />
            <Route path="/ordermanagement/createnewbulkorder" element={<CreateBulkOrder/>} />
            <Route path="/ordermanagement/createnewbulkorder/:id/:orderflow" element={<CreateBulkOrder/>} />
            <Route path="/ordermanagement/dispositionpenaltyfee" element={<DispositionPenaltyFee/>}/>
            <Route path="/ordermanagement/blank" element={<BlankPage />} />
            <Route path="/errorLogs" element={<ExceptionErrorLogs />} />
            <Route path="/ordermanagement/createacquisitionnewcode" element={<AcquisitionCodeMaintenanceListing />} />
            <Route path="/ordermanagement/acquisitioncodemaintenance" element={<AcquisitionCodeMaintenance/>} />
            <Route path="/ordermanagement/dispositionpenaltyflag" element={<DispositionPenaltyFlag/>} />
            <Route path="/ordermanagement/assetauditresethistory" element={<AssetAuditResetHistoryLog/>} />
            <Route path="/ordermanagement/approval" element={<ApprovalDashboard/>} />
            <Route path="/ordermanagement/approval/approvalhistory/:id" element={<ApprovalHistoryDetails />} />
            <Route path="/ordermanagement/approval/complianceauditreport/:id/:entitytype/:date" element={<ComplianceAuditReport />} />
            <Route path="/ordermanagement/outofofficeoverride" element={<OutOfOffice/>}/>
            <Route path="/ordermanagement/Admin/:page" element={<Admin/>} />
            <Route path="/Admin/:page" element={<Admin/>} />

            {/* for UI reference added routing for error-page , can be removed if not required */}
            <Route path="/error-handling" element={<ErrorPage />} />
            <Route path="/assetinventory/*" element={<AssetInventory />} />
            <Route path="/autocomplete" element={<AutoCompleteTest />} />
            <Route path="/bulkorder/*" element={<BulkOrder />} />
            <Route path="/callus" element={<CallUs/>} />
            <Route path="/assetinventory/addUserBycostCenter" element={<AddUserByCostCenter />} />
            <Route path="/assetinventory/branchAdminAccess" element={<BranchAdminAccess />} />
            {/* uncomment this route while enabling Active Asset from common dashboard */}
            {/* <Route path="/activeasset/*" element={<ActiveAsset/>} /> */}
            <Route path="/ordermanagement/activeasset/report" element={<ActiveAssetReport/>} />
            <Route path="/ordermanagement/activeasset" element={<ActiveAssetRegister/>} />
            <Route path="/ordermanagement/activeasset/activeassetdashboard/:assetnumber/:pagename?" element={<ActiveAssetDashboard/>} />
            <Route path="/ordermanagement/BarcodeReplacement" element={<BarcodeReport />} />
            
          </Routes>
        </Layout>
        ) 
        : null }            
       
        {getSpinner()}
      {/*</AuthenticatedTemplate>*/}
    </div>
  );
}

export default App;
